import React, { useState, useEffect, useRef } from 'react';
import { Table, Button, Form, Input, Select, Spin, Space, Popover } from 'antd';
import { HomeOutlined, SearchOutlined, RedoOutlined, DownloadOutlined } from '@ant-design/icons';
import Message from '../../component/message/message'; // 提示信息弹窗
import moment from 'moment';//日期格式化导包
import PopupFrame from '../../component/popupFrame/popupFrame';
import Audit from '../../component/audit/audit';//审核彈框
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import context from '../../public/js/context';
import { ContextHandler } from '../../public/js/contextHandler';
import trans from './translation';
import './surveyRecordReport.css';
const { Option } = Select;

const SurveyRecordReport = () => {

    const messageRef = useRef();
    const [form] = Form.useForm();
    const [tabIndex, setTabIndex] = useState("1");
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState([]);
    const [flag, setFlag] = useState("add");
    const [isAudit, setIsAudit] = useState(false);
    const [isDeleteFrame, setIsDeleteFrame] = useState(false);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [auditModel, setAuditModel] = useState({});
    const [isLoad, setIsLoad] = useState(false);
    const [spinInfo, setSpinInfo] = useState("");
    const [isLeave, setIsLeave] = useState(false);
    const [deleteTipText, setDeleteTipText] = useState("");
    const [downloadModel, setDownloadModel] = useState("");
    const [surveyTemplateList, setSurveyTemplateList] = useState([]);

    useEffect(() => {
        searchSurvetTemplateList();
        search(pageSize, 1, "N");
    }, []);

    const searchSurvetTemplateList = () => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        Base.callBackApi("surveyTemplate/searchAll").then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object ?? []
                setSurveyTemplateList(list)
            } else {
                errFrameShow("error", data.msg);
            }
        })
    }

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        messageShowHandler();  // 清除提示信息
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        model.progCodeList = Config.userInfo?.progCodeList
        setDownloadModel(model)
        setIsLoad(true);
        setSpinInfo(trans.beQuerying[Config.backLang]);
        Base.callBackApi("surveyRecord/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(() => { }).finally(() => setIsLoad(false));
    }

    const searchChange = (key, value) => {
        messageShowHandler();
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const reset = () => {
        messageShowHandler();
        clearSelect();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    // Tab页切换
    const handleSelect = (key) => {
        if (key) {
            if (key === "2") {
                if (checkboxState.length === 1 && Config.funcInfo.canUpdate === "Y") {
                    edit();
                } else if (Config.funcInfo.canInsert === "Y") {
                    add();
                }
            } else if (tabIndex !== "1") {
                setTabIndex("1");
                search(pageSize, current, "Y");
            }
        }
    }

    const add = () => {
        messageShowHandler();
        initForm({
        });
        setFlag("add");
        setTabIndex("2");
    }

    const edit = () => {
    }

    const initForm = (model = {}) => {
        form.resetFields();
        form.setFieldsValue({
            surveyTemplateId: model.surveyTemplateId ?? "",
            description: model.description ?? "",
            receiver: model.receiver ?? "",
            endDate: model.endDate ? moment(new Date(model.endDate), Config.dateFormat5) : "",
            remindEmailDate: model.remindEmailDate ? moment(new Date(model.remindEmailDate), Config.dateFormat5) : "",
        });
    }

    const deleteFrameClose = (state) => {
        if (state) {
            deleteData();
        }
        clearSelect();
        setIsDeleteFrame(false);
    }

    const deleteData = () => {
        setIsLoad(true);
        setSpinInfo(trans.deleteData[Config.backLang]);
        let deleteModel = checkboxState[0];
        deleteModel.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi("survey/delete", deleteModel).then((data) => {
            if ("SUCCESS" === data.msg) {
                cancel();
                search(pageSize, current, "Y", false);
                errFrameShow("success", trans.deleteSuccess[Config.backLang]);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(() => { }).finally(() => setIsLoad(false));
    }

    const audit = (model, e) => {
        messageShowHandler();//清空提示信息
        e.stopPropagation();
        setAuditModel(model);
        setIsAudit(true);
    }

    const auditCancel = () => {
        setIsAudit(false);
    }

    const cancel = () => {
        messageShowHandler();
        clearSelect();
        setTabIndex("1");
        search(pageSize, current, "Y");
    }

    const leaveFrameClose = (state) => {
        if (state) {
            cancel();
        }
        setIsLeave(false);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    //清空列表选中
    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([]);
    }

    // 生成提示信息
    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    // 清除提示信息
    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const downloadExcel = () => {
        messageShowHandler();//清空提示信息
        setIsLoad(true);
        setSpinInfo(trans.download[Config.backLang])
        const filename = "Evaluation Survey Report" + moment(new Date()).format(Config.dateFormat3) + Base.generateFourDigitRandomNumber() + ".xlsx"
        fetch(Config.apiDownloadServer + "surveyRecord/exportReport", {
            method: 'POST',
            body: JSON.stringify(downloadModel),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.blob()).then(blob => {
            if (blob.type == "application/json") {
                var reader = new FileReader();
                reader.onload = e => {
                    var data = JSON.parse(e.target.result);
                    errFrameShow("error", data.msg);
                }
                reader.readAsText(blob);
            } else {
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {// for IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {// for Non-IE (chrome, firefox etc.)
                    var a = document.createElement('a');
                    document.body.appendChild(a);
                    a.style = 'display: none';
                    var url = window.URL.createObjectURL(blob);
                    a.href = url;
                    a.download = filename
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                }
            }
        }).catch(err => ({ err })).finally(() => {
            setIsLoad(false)
        });
    }

    /*eslint-disable*/
    const columns = [
        {
            title: 'Sending ID',
            dataIndex: 'surveyId',
            width: '1.6%'
        },
        {
            title: 'Cohort',
            dataIndex: 'cohortYear',
            width: '1.2%'
        },
        {
            title: 'End Date',
            dataIndex: 'endDate',
            width: '1.6%',
            render: text => text ? moment(text).format(Config?.dateFormatEn) : ''
        },
        {
            title: 'Description',
            dataIndex: 'description',
            width: '2%'
        },
        {
            title: 'Company Name',
            dataIndex: 'companyName',
            width: '2.5%',
            render: (text) => <Popover content={text} title="" trigger="hover">
                <div className = "tableEllipsisBoxClamp">{text}</div>
            </Popover>
        },
        {
            title: 'Email',
            dataIndex: 'email',
            width: '2%',
        },
        {
            title: 'Complection Date',
            dataIndex: 'completedDate',
            width: '2.6%',
            render: text => text ? moment(text).format(Config?.dateFormatEn) : ''
        },
        {
            title: 'Status',
            dataIndex: 'status',
            width: '1.7%',
            render: text => ContextHandler.getMapValue('surveyRecordStatusMap', text),
        },
        {
            title: 'Organisation Name',
            dataIndex: 'organisationName',
            width: '2.8%',
        },
        {
            title: 'Programme',
            dataIndex: 'progTitles',
            width: '2%',
        },
        {
            title: "Section A",
            children: [
                {
                    title: 'Q1',
                    dataIndex: 'sectionAQuestion1',
                    width: '3%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q1 Result',
                    dataIndex: 'sectionAQuestionResult1',
                    width: '2%',
                },
                {
                    title: 'Q2',
                    dataIndex: 'sectionAQuestion2',
                    width: '3%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q2 Result',
                    dataIndex: 'sectionAQuestionResult2',
                    width: '2%',
                },
                {
                    title: 'Q3',
                    dataIndex: 'sectionAQuestion3',
                    width: '3%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q3 Result',
                    dataIndex: 'sectionAQuestionResult3',
                    width: '2%',
                },
                {
                    title: 'Q4',
                    dataIndex: 'sectionAQuestion4',
                    width: '3%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q4 Result',
                    dataIndex: 'sectionAQuestionResult4',
                    width: '2%',
                },
                {
                    title: 'Q5',
                    dataIndex: 'sectionAQuestion5',
                    width: '3%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q5 Result',
                    dataIndex: 'sectionAQuestionResult5',
                    width: '2%',
                },
                {
                    title: 'Q6',
                    dataIndex: 'sectionAQuestion6',
                    width: '3%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q6 Result',
                    dataIndex: 'sectionAQuestionResult6',
                    width: '2%',
                },
                {
                    title: 'Q7',
                    dataIndex: 'sectionAQuestion7',
                    width: '3%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q7 Result',
                    dataIndex: 'sectionAQuestionResult7',
                    width: '2%',
                },
                {
                    title: 'Q8',
                    dataIndex: 'sectionAQuestion8',
                    width: '3%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q8 Result',
                    dataIndex: 'sectionAQuestionResult8',
                    width: '2%',
                },
                {
                    title: 'Q9',
                    dataIndex: 'sectionAQuestion9',
                    width: '3%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q9 Result',
                    dataIndex: 'sectionAQuestionResult9',
                    width: '2%',
                },
                {
                    title: 'Q10',
                    dataIndex: 'sectionAQuestion10',
                    width: '3%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q10 Result',
                    dataIndex: 'sectionAQuestionResult10',
                    width: '2%',
                },
            ],
        },
        {
            title: "Section B",
            children: [
                {
                    title: 'Q1',
                    dataIndex: 'sectionBQuestion1',
                    width: '3%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q1 Result',
                    dataIndex: 'sectionBQuestionResult1',
                    width: '2%',
                },
            ]
        },
        {
            title: "Section C",
            children: [
                {
                    title: 'Q1',
                    dataIndex: 'sectionCQuestion1',
                    width: '3%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q1 Result',
                    dataIndex: 'sectionCQuestionResult1',
                    width: '2%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q2',
                    dataIndex: 'sectionCQuestion2',
                    width: '3%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q2 Result',
                    dataIndex: 'sectionCQuestionResult2',
                    width: '2%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q3',
                    dataIndex: 'sectionCQuestion3',
                    width: '3%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q3 Result',
                    dataIndex: 'sectionCQuestionResult3',
                    width: '2%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q4',
                    dataIndex: 'sectionCQuestion4',
                    width: '3%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q4 Result',
                    dataIndex: 'sectionCQuestionResult4',
                    width: '2%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q5',
                    dataIndex: 'sectionCQuestion5',
                    width: '3%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
                {
                    title: 'Q5 Result',
                    dataIndex: 'sectionCQuestionResult5',
                    width: '2%',
                    render: (text) => <Popover content={text} title="" trigger="hover">
                        <div className = "tableEllipsisBoxClamp">{text}</div>
                    </Popover>
                },
            ],
        },
    ];


    return (
        <div id="container" className="template surveyRecordReport">
            <div className='breadcrumb'>
                <HomeOutlined /> / Admin / <span className='breadcrumbTitle'>{Config.funcInfo['funcName' + (Config.backLang === 'TC' ? 'Tc' : '')]}</span>
            </div>
            {/* 提示信息弹框 */}
            <Message ref={messageRef} />     
            <div className='templateMain'>
                <Spin size="large" spinning={isLoad} tip={spinInfo}>
                    {/* 删除弹框 */}
                    {isDeleteFrame ? <PopupFrame close={deleteFrameClose} deleteTipText={deleteTipText} /> : null}
                    {isLeave ? <PopupFrame close={leaveFrameClose} type='leave' /> : null}
                    {/* 审核彈框 */}
                    <Audit visible={isAudit} auditModel={auditModel} close={auditCancel} />
                    <div className='sysSearchRow sysSearchBox'>
                        <div className='sysRow'>
                            <div className='sysCol'>
                                <div className="sysTitle ">{trans.cohortYear[Config.backLang]}</div>
                                <div className="sysSerchInput">
                                    <Select className="sysSelect" placeholder={trans.cohortYear[Config.backLang]}
                                        value={searchModel.surveyTemplateId || ''}
                                        onChange={(e) => searchChange('surveyTemplateId', e)}
                                    >
                                        <Option value=''></Option>
                                        {surveyTemplateList.map((item) => <Option key={item.surveyTemplateId} value={item.surveyTemplateId}>{item.cohortYear}</Option>)}
                                    </Select>
                                </div>
                            </div>
                            <div className='sysCol'>
                                <div className="sysTitle">Programme Name</div>
                                <div className="sysSerchInput">
                                    <Input type="text" value={searchModel.progTitle || ''}
                                        placeholder='Programme Name'
                                        onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                        onChange={(e) => searchChange('progTitle', e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className='sysCol'>
                                <div className="sysTitle">Status</div>
                                <div className="sysSerchInput">
                                    <Select className="sysSelect" placeholder='Status'
                                        value={searchModel.status || ''}
                                        onChange={(e) => searchChange('status', e)}
                                    >
                                        <Option value=""></Option>
                                        {context.surveyRecordStatusMap.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)}
                                    </Select>
                                </div>
                            </div>
                            <div className='sysCol'>
                                <div className="sysTitle ">Company Name</div>
                                <div className="sysSerchInput">
                                    <Input type="text" value={searchModel.companyName || ''}
                                        placeholder='Company Name'
                                        onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                        onChange={(e) => searchChange('companyName', e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className='sysCol'>
                                <div className="sysTitle">Email</div>
                                <div className="sysSerchInput">
                                    <Input type="text" value={searchModel.email || ''}
                                        placeholder='Email'
                                        onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                        onChange={(e) => searchChange('email', e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className='sysSearchButton'>
                                <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>Search</Button>
                                <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>Reset</Button>
                            </div>
                        </div>
                    </div>
                    <div className="sysLineEight"></div>
                    <Space size={[5, 5]} wrap className="sysButtonRelative">
                    {tables.length == 0 ? null :
                        <>
                            <Button className="sysBtn btnBlue" type="primary" onClick={downloadExcel} hidden={Config.funcInfo.canDownload === "N"} icon={<DownloadOutlined />}>Export</Button>
                        </>
                    }
                    </Space>
                    <div className="sysTable" id="tableOne">
                        <Table
                            scroll={{ x: 6000 }}
                            rowKey="surveyRecordId" //Key值
                            columns={columns} //列名
                            dataSource={tables} //数据
                            pagination={{  //分页
                                showSizeChanger: true,                //是否显示可以设置几条一页的选项
                                onChange: onChange,                  //上页下页或者跳页方法
                                onShowSizeChange: onShowSizeChange,          //每页显示条数方法
                                total: tablesCount,        //总共多少条数据
                                current: current,       //当前页
                                pageSize: pageSize,  //每页显示多少条数据
                                defaultCurrent: 1,          //默认当前页为1
                                size: "small"
                            }}
                        />
                    </div>
                </Spin>
            </div>
        </div>
    )

}

export default SurveyRecordReport;